import {gql} from 'apollo-boost';

export const GET_LIVECLASSSCHEDULE = gql`
  query getLiveClassSchedule($id : ID!){
    getLiveClassSchedule (
      id: $id
    ) {
      id periodCode degreeCode subjectGroupCode subjectCode subjectName
      teacherCode teacherFullName sectionNo topicLocal topicEng
      dateTimeFrom dateTimeTo liveFrom contract remark externalLink externalPassword
      rtmpServer rtmpStream isEnabled
      academicPeriod { id periodCode }
      degree { id code nameLocal nameEng }
      subjectGroup { id code nameLocal nameEng }
      subject { id code nameLocal nameEng }
      teacher  { id code firstNameLocal lastNameLocal firstNameEng lastNameEng picturePath
        telephone email socialMedia availableTime isSpecialTeacher picturePath label
      }
      courseOutlineRegistration  { id }
      classSection { id sectionNo descriptionLocal descriptionEng
        startClassDate learnSpanNo examSpanNo studentRegisterQty
        classRoom{
          id
          nameLocal
          nameEng
          studentRegisterQty
          capacity
          startDate
          endDate
          courseOutlineRegistration{
            id
            courseOutline {
              id courseOutlineUnits{
                id seq nameLocal nameEng
              }
            }
          }
          degree{ id code }
          subjectGroup{ id code}
          classSection{
            id sectionNo descriptionLocal descriptionEng startClassDate
            learnSpanNo examSpanNo studentQty studentRegisterQty
          }
          teacher{
            id code firstNameLocal lastNameLocal firstNameEng lastNameEng picturePath
            telephone email availableTime socialMedia isSpecialTeacher
          }
          subject{
            id code nameLocal nameEng
          }
        }
        vdoSet{
          id code totalVdoLength
          vdoSetUnits {
            id unitSeq
            vdoSetTopics{
              id vdoStreamPath
              playbackUrl
              playbackStatus
              videoProvider
              bunnyVideoGuid
              bunnyStatus
            }
          }
        }
        courseOutline{
          id
          courseOutlineUnits{ id }
        }
      }
      courseOutlineUnit { id seq nameLocal nameEng }
    }
  }
`;

export const GET_LIVECLASSSCHEDULES_BY_FILTER = gql`

  query getLiveClassSchedulesByFilter($liveClassScheduleFilterInput: LiveClassScheduleFilterInput){
    getLiveClassSchedulesByFilter (
      liveClassScheduleFilterInput:$liveClassScheduleFilterInput
    ){
      id periodCode degreeCode subjectGroupCode subjectCode subjectName
      teacherCode teacherFullName sectionNo topicLocal topicEng
      dateTimeFrom dateTimeTo liveFrom contract remark externalLink externalPassword
      rtmpServer rtmpStream isEnabled
      academicPeriod { id periodCode }
      degree { id code nameLocal nameEng }
      subjectGroup { id code nameLocal nameEng }
      subject { id code nameLocal nameEng }
      teacher  { id code firstNameLocal lastNameLocal firstNameEng lastNameEng picturePath  }
      courseOutlineRegistration  { id }
      classSection { id sectionNo  }
      courseOutlineUnit { id seq nameLocal nameEng }

    }
  }
`;

export const GET_LIVECLASSSCHEDULES_BY_FILTER_FOR_TABLE = gql`

  query getLiveClassSchedulesByFilter($liveClassScheduleFilterInput: LiveClassScheduleFilterInput){
    getLiveClassSchedulesByFilter (
      liveClassScheduleFilterInput:$liveClassScheduleFilterInput
    ){
      id periodCode degreeCode subjectGroupCode subjectCode subjectName
      teacherCode teacherFullName sectionNo topicLocal topicEng
      dateTimeFrom dateTimeTo liveFrom contract remark externalLink externalPassword
      rtmpServer rtmpStream isEnabled
      subject { id code nameLocal nameEng }
      teacher  { id code firstNameLocal lastNameLocal firstNameEng lastNameEng picturePath  }
      classSection { id sectionNo  }
      courseOutlineUnit { id seq nameLocal nameEng }

    }
  }
`;

export const GET_LIVECLASSSCHEDULES = gql`
  query getLiveClassSchedules {
    getLiveClassSchedules {
      id
      periodCode
      degreeCode
      subjectGroupCode
      subjectCode
      subjectName
      teacherCode
      teacherFullName
      sectionNo
      topicLocal
      topicEng
      dateTimeFrom
      dateTimeTo
      liveFrom
      contract
      remark externalLink externalPassword
      rtmpServer
      rtmpStream
      isEnabled
      academicPeriod {
        id
        periodCode
      }
      degree {
        id
        code
        nameLocal
        nameEng
      }
      subjectGroup {
        id
        code
        nameLocal
        nameEng
      }
      subject {
        id
        code
        nameLocal
        nameEng
      }
      teacher {
        id
        code
        firstNameLocal
        lastNameLocal
        firstNameEng
        lastNameEng
        picturePath
      }
      courseOutlineRegistration {
        id
      }
      classSection {
        id
        sectionNo
      }
      courseOutlineUnit {
        id
        seq
        nameLocal
        nameEng
      }
    }
  }
`;

export const GET_LIVECLASSSCHEDULES_CURRENT_USER = gql`
  query getLiveClassSchedulesCurrentUser {
    getLiveClassSchedulesCurrentUser {
      id periodCode degreeCode subjectGroupCode subjectCode subjectName
      teacherCode teacherFullName sectionNo topicLocal topicEng
      dateTimeFrom dateTimeTo liveFrom contract remark externalLink externalPassword
      rtmpServer rtmpStream isEnabled
      academicPeriod { id periodCode }
      degree { id code nameLocal nameEng }
      subjectGroup { id code nameLocal nameEng }
      subject { id code nameLocal nameEng }
      teacher  { id code firstNameLocal lastNameLocal firstNameEng lastNameEng picturePath  }
      courseOutlineRegistration  { id }
      classSection { id sectionNo learnSpanNo }
      courseOutlineUnit { id seq nameLocal nameEng }
    }
  }
`;

export const ADD_LIVECLASSSCHEDULE = gql`
  mutation addLiveClassSchedule(
    $degreeId: ID
    $subjectGroupId: ID
    $subjectId: ID
    $teacherId: ID
    $academicPeriodId: ID
    $courseOutlineRegistrationId: ID
    $classSectionId: ID
    $courseOutlineUnitId: ID
    $liveClassScheduleInput: LiveClassScheduleInput!
  ) {
    addLiveClassSchedule(
      degreeId: $degreeId
      subjectGroupId: $subjectGroupId
      subjectId: $subjectId
      teacherId: $teacherId
      academicPeriodId: $academicPeriodId
      courseOutlineRegistrationId: $courseOutlineRegistrationId
      classSectionId: $classSectionId
      courseOutlineUnitId: $courseOutlineUnitId
      liveClassScheduleInput: $liveClassScheduleInput
    ) {
      id periodCode degreeCode subjectGroupCode subjectCode subjectName
      teacherCode teacherFullName sectionNo topicLocal topicEng
      dateTimeFrom dateTimeTo liveFrom contract remark externalLink externalPassword
      rtmpServer rtmpStream isEnabled
      academicPeriod { id periodCode }
      degree { id code nameLocal nameEng }
      subjectGroup { id code nameLocal nameEng }
      subject { id code nameLocal nameEng }
      teacher  { id code firstNameLocal lastNameLocal firstNameEng lastNameEng picturePath  }
      courseOutlineRegistration  { id }
      classSection { id sectionNo  }
      courseOutlineUnit { id seq nameLocal nameEng }
    }
  }
`;

export const UPDATE_LIVECLASSSCHEDULE = gql`
  mutation updateLiveClassSchedule(
    $id: ID!,
    $degreeId: ID
    $subjectGroupId: ID
    $subjectId: ID
    $teacherId: ID
    $academicPeriodId: ID
    $courseOutlineRegistrationId: ID
    $classSectionId: ID
    $courseOutlineUnitId: ID
    $liveClassScheduleInput: LiveClassScheduleInput!
  ) {
    updateLiveClassSchedule(
      id: $id
      degreeId: $degreeId
      subjectGroupId: $subjectGroupId
      subjectId: $subjectId
      teacherId: $teacherId
      academicPeriodId: $academicPeriodId
      courseOutlineRegistrationId: $courseOutlineRegistrationId
      classSectionId: $classSectionId
      courseOutlineUnitId: $courseOutlineUnitId
      liveClassScheduleInput: $liveClassScheduleInput
    ) {
      id periodCode degreeCode subjectGroupCode subjectCode subjectName
      teacherCode teacherFullName sectionNo topicLocal topicEng
      dateTimeFrom dateTimeTo liveFrom contract remark externalLink externalPassword
      rtmpServer rtmpStream isEnabled
      academicPeriod { id periodCode }
      degree { id code nameLocal nameEng }
      subjectGroup { id code nameLocal nameEng }
      subject { id code nameLocal nameEng }
      teacher  { id code firstNameLocal lastNameLocal firstNameEng lastNameEng picturePath  }
      courseOutlineRegistration  { id }
      classSection { id sectionNo  }
      courseOutlineUnit { id seq nameLocal nameEng }
    }
  }
`;

export const DELETE_LIVECLASSSCHEDULE = gql`
  mutation deleteLiveClassSchedule($id: ID!) {
    deleteLiveClassSchedule(
      id: $id
    ) {
      id periodCode degreeCode subjectGroupCode subjectCode subjectName
      teacherCode teacherFullName sectionNo topicLocal topicEng
      dateTimeFrom dateTimeTo liveFrom contract remark externalLink externalPassword
      rtmpServer rtmpStream isEnabled
      academicPeriod { id periodCode }
      degree { id code nameLocal nameEng }
      subjectGroup { id code nameLocal nameEng }
      subject { id code nameLocal nameEng }
      teacher  { id code firstNameLocal lastNameLocal firstNameEng lastNameEng picturePath  }
      courseOutlineRegistration  { id }
      classSection { id sectionNo  }
      courseOutlineUnit { id seq nameLocal nameEng }
    }
  }
`;

